import type {
  BatchStatus,
  RollbackScope,
  SettlementCompleteDateAdjustmentSource,
  SettlementItemPeriodType,
  SettlementItemStatus,
  SettlementItemType,
} from '../../../lib/api/settlementCompleteDateAdjustment';

/**
 * 정산아이템/배치의 영문 enum 값을 화면 표시용 한국어로 매핑.
 * 백엔드의 SETTLEMENT_ITEM_*_SWAGGER_MAP 과 맞추고, 기존 정산 페이지 컨벤션과 일관성 유지.
 */
export const SETTLEMENT_ITEM_TYPE_LABEL: Record<SettlementItemType, string> = {
  order: '상품 주문',
  extraDelivery: '추가 배송비',
  returnDelivery: '반품 배송비',
};

export const SETTLEMENT_ITEM_STATUS_LABEL: Record<SettlementItemStatus, string> = {
  ready: '정산 대기',
  completed: '정산 완료',
  hold: '정산 보류',
};

export const SETTLEMENT_ITEM_PERIOD_TYPE_LABEL: Record<
  SettlementItemPeriodType,
  string
> = {
  daily: '일정산',
  monthly: '월정산',
};

export const SETTLEMENT_COMPLETE_DATE_ADJUSTMENT_BATCH_STATUS_LABEL: Record<
  BatchStatus,
  string
> = {
  pending: '실행 대기',
  executed: '실행 완료',
  partiallyRolledBack: '부분 롤백',
  fullyRolledBack: '전체 롤백',
  failed: '실패',
};

/**
 * 관리처 코드 → 한국어 라벨.
 */
export const SETTLEMENT_MANAGEMENT_LABEL: Record<number, string> = {
  0: '브랜드',
  1: '아몬즈',
};

/**
 * 롤백 대상 범위(scope) → 한국어 라벨. 사용자 확인 모달 등 UI 노출용.
 */
export const ROLLBACK_SCOPE_LABEL: Record<RollbackScope, string> = {
  all: '활성 전체',
  byIds: '선택한 정산 ID',
  byStoreId: '특정 브랜드',
  byOrderItemIds: '특정 상품 주문',
};

/**
 * Preview 응답의 excluded.reason union.
 * 백엔드 settlement-complete-date-adjustments.service.ts 의 preview() 에서 push 하는 값.
 *
 * 백엔드 응답 contract 와 동기화 — 신규 사유 추가 시 양쪽 함께 갱신.
 */
export type PreviewExcludedReason =
  | 'notFound'
  | 'nonCompleted'
  | 'nullCompleteDate';

/**
 * Preview 응답의 excluded.reason → 사용자 노출용 한국어 라벨.
 */
export const PREVIEW_EXCLUDED_REASON_LABEL: Record<PreviewExcludedReason, string> = {
  notFound: '존재하지 않음',
  nonCompleted: '정산 완료 상태가 아님',
  nullCompleteDate: '완료일 누락 (데이터 무결성 손상)',
};

/**
 * UI 선정 방식(source) → 한국어 라벨. 이력 리스트/상세 표시 + 버그 트래킹 시
 * "테이블 체크로 고른 건지, 엑셀 업로드인지" 재현 경로 파악용.
 */
export const SETTLEMENT_COMPLETE_DATE_ADJUSTMENT_SOURCE_LABEL: Record<
  SettlementCompleteDateAdjustmentSource,
  string
> = {
  tableSelection: '테이블 선택',
  excelUpload: '엑셀 업로드',
};
